<template>
    <div class="chat-list">
        <!---
        <button
            type="button"
            class="btn btn-primary mb-5 d-flex align-items-center"
            @click="$emit('startChat')"
        >
            <i class="fal fa-comments mr-2"></i>
            Start a chat
        </button>
        -->
        <ul v-if="notificationChats.length" class="list-group">
            <chat-item
                v-for="chat in notificationChats"
                :key="'notif-' + chat.id"
                :chat="chat"
                :isSelected="selectedChat && chat.id === selectedChat.id"
                @select="selectChat(chat)"
            ></chat-item>
        </ul>
        <hr v-if="notificationChats.length" class="solid">
        <chat-tabs :activeTab="activeTab" @changeTab="changeTab"></chat-tabs>
        <div class="chat-items">
            <ul class="list-group">
                <chat-item
                    v-for="chat in filteredChats"
                    :key="chat.id"
                    :chat="chat"
                    :isSelected="selectedChat && chat.id === selectedChat.id"
                    @select="selectChat(chat)"
                ></chat-item>
            </ul>
        </div>
    </div>
</template>

<script>
    import ChatTabs from './ChatTabs.vue'
    import ChatItem from './ChatItem.vue'

    function lastActivityAt(chat) {
        return new Date(chat.last_message ? chat.last_message.created_at : chat.created_at).getTime();
    }

    export default {
            name: 'ChatList',
            props: {
                selectedChat: {
                    type: Object,
                    default: null
                },
                chats: {
                    type: Array,
                    required: false
                }
            },
            components: {
                ChatTabs,
                ChatItem
        },
        data() {
            return {
                activeTab: 'Open',
            }
        },
        computed: {
            notificationChats() {
                return this.chats.filter(chat => chat.isNotification);
            },
            filteredChats() {
                const regularChats = this.chats.filter(chat => !chat.isNotification);
                let chats = [];
                if (this.activeTab === 'All') {
                    chats = regularChats.filter(chat => chat.status !== 'resolved');
                } else {
                    chats = regularChats.filter(chat => this.filterTab(chat.status, this.activeTab));
                }

                return chats.sort((a, b) => lastActivityAt(b) - lastActivityAt(a));
            }
        },
        methods: {
            filterTab(chatStatus, activeTab) {
                const isResolved = chatStatus === 'resolved'
                const isArchivedTab = activeTab === 'Archived'
                return isResolved === isArchivedTab
            },
            changeTab(tab) {
                this.activeTab = tab
            },
            selectChat(chat) {
                this.$emit('chatSelected', chat)
            }
        }
    }
</script>

<style scoped>
    .chat-list {
        display: flex;
        flex-direction: column;
        height: 100%;
        min-height: 0;
    }
    .chat-items {
        display: flex;
        flex-direction: column;
        overflow-y: auto;
        flex: 1 1 0;
        min-height: 0;
    }
    .chat-list .btn {
        padding: 1rem 2rem;
        font-size: 1.6rem;
        border-radius: 10px;
        line-height: 1;
        color: #fff;
        font-weight: 600;
    }
</style>
  